import ApiService from "../../../commons/api/api_service";
import BaseResponse from "../../../commons/api/base_response";
import { Endpoints } from "../../../commons/api/endpoints";
import { ProviderVM } from "../../../commons/base/providers/view_model";
import {
    CompletenessResponseBody,
    responseCompletenessDetail,
} from "../models/completeness_response";

export default class CompletenessViewModel extends ProviderVM {
    isLoading: boolean = true;
    errorMessage: string = "";
    so: responseCompletenessDetail[] = [];
    waste: responseCompletenessDetail[] = [];
    dateWaste = "";

    constructor() {
        super();

        this.loadCompleteness();
    }

    get soGroupDate() {
        const dates = Array.from(
            new Set(
                this.so.flatMap((item) =>
                    Object.keys(item).filter((key) => key !== "outlet")
                )
            )
        );
        return dates;
    }

    get wasteGroupDate() {
        const dates = Array.from(
            new Set(
                this.waste.flatMap((item) =>
                    Object.keys(item).filter((key) => key !== "outlet")
                )
            )
        );
        return dates;
    }

    // get pivotSOByDate() {
    //     return this.pivotByDate(this.so, "created_date");
    // }

    // get pivotWasteByDate() {
    //     return this.pivotByDate(this.so, "created_date");
    // }

    // pivotByDate = (
    //     items: responseCompletenessDetail[],
    //     dateKey: string
    // ): { [key: string]: responseCompletenessDetail[] } => {
    //     return items.reduce((acc, item) => {
    //         const date = new Date(
    //             item[dateKey as keyof responseCompletenessDetail]
    //         ).toLocaleDateString();
    //         if (!acc[date]) {
    //             acc[date] = [];
    //         }
    //         acc[date].push(item);
    //         return acc;
    //     }, {} as { [key: string]: responseCompletenessDetail[] });
    // };

    loadCompleteness() {
        this.emit(() => {
            this.isLoading = true;
            this.errorMessage = "";
        });

        ApiService.fetch<{}, BaseResponse<CompletenessResponseBody>>(
            Endpoints.getCompleteness,
            {
                onSuccess: (response) => {
                    console.log(response.data);
                    this.emit(() => {
                        this.isLoading = false;
                        this.so = response.data?.so || [];
                        this.waste = response.data?.waste || [];
                    });
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoading = false;
                    });
                },
            }
        );
    }

    retryAction() {
        this.loadCompleteness();
    }
}
